export default "__VITE_ASSET__eb02f97b__"